// extracted by css-extract-rspack-plugin
export default {"blueTable":"src-app-pages-human-commute-Day-Day-module__blueTable-DG4al7","head":"src-app-pages-human-commute-Day-Day-module__head-H3Bcoh","caption":"src-app-pages-human-commute-Day-Day-module__caption-ecR2n9","highlight":"src-app-pages-human-commute-Day-Day-module__highlight-SEkni5","links":"src-app-pages-human-commute-Day-Day-module__links-qQnnxG"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"blueTable\":\"src-app-pages-human-commute-Day-Day-module__blueTable-DG4al7\",\"head\":\"src-app-pages-human-commute-Day-Day-module__head-H3Bcoh\",\"caption\":\"src-app-pages-human-commute-Day-Day-module__caption-ecR2n9\",\"highlight\":\"src-app-pages-human-commute-Day-Day-module__highlight-SEkni5\",\"links\":\"src-app-pages-human-commute-Day-Day-module__links-qQnnxG\"}";
        // 1789362522819
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  